import axios from 'axios'

export default {
  namespaced: true,
  state: {
    moyensDePaiement: [],
  },
  mutations: {
    SET_MOYENS_DE_PAIEMENTS(state, _moyenDePaiements) {
      state.moyensDePaiement = _moyenDePaiements
    },
  },
  getters: {
    getMoyenDePaiements(state) {
      return state.moyensDePaiement
    },
    findMoyenDePaiementById: (state) => (moyenDePaiementId) => {
      return state.moyensDePaiement.find((moyenDePaiement) => moyenDePaiement.moyenDePaiementId === moyenDePaiementId)
    },
    getIconePourMoyenDePaiementAimId: () => (_moyenDePaiementId) => {
      switch (_moyenDePaiementId) {
        case 'ESPECE':
          return 'mdi-hand-coin'
        case 'VIREMENT':
          return 'mdi-swap-horizontal'
        case 'CHEQUE':
          return 'mdi-checkbook'
        default:
          return 'mdi-circle'
      }
    },
    getCouleurPourMoyenDePaiementAimId: () => (_moyenDePaiementId) => {
      switch (_moyenDePaiementId) {
        case 'ESPECE':
          return '#ffde57'
        case 'VIREMENT':
          return '#3dadf8'
        case 'CHEQUE':
          return '#529a69'
        default:
          return 'grey'
      }
    },
  },
  actions: {
    fetchMoyenDePaiements({ commit }) {
      return axios.get(`${process.env.VUE_APP_URL_BACK_SERENITY}/moyenDePaiement`).then((response) => {
        commit('SET_MOYENS_DE_PAIEMENTS', response.data)
      })
    },
  },
}
